import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { getPolicyValidationInfoSaga } from './getPolicyValidationInfoSaga';

export function* executePolicyTransactionCustomActionSaga({ payload }) {
    try {
        yield put(reduceLoading({ code: 'executePolicyTransactionCustomAction', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/PolicyTransactionCustomAction/IssueQuoteAndSendPaymentLink', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        const result = yield call([response, 'json']);

        yield put(reduceOperation(result.operation));

        // Only reload if the operation was successful
        if (result.operation?.status) {
            window.location.reload();
        }
        // Call ValidationInfo if there are no Operation errors
        if (!result.operation?.status && result.operation?.errors?.length === 0) {
            yield call(getPolicyValidationInfoSaga);
        }
    } catch (error) {
        console.log('Error while executing Policy Transaction Custom Action', error);
    } finally {
        yield put(reduceLoading({ code: 'executePolicyTransactionCustomAction', value: false }));
    }
}
